package core

import core.localStorage.LocalStorageDAO
import react.ReducerInstance
import react.createContext
import kotlin.reflect.KProperty

/**
 * Copyright (c) emgress GmbH. All rights reserved.
 *
 * Created on : 17.10.22
 * Author : marcusspors
 */
val AppContext = createContext<MyAppContext>()

class MyAppContext(
    val mIsLoading: Boolean = false,

    val mSetIsLoading: (bool: Boolean) -> Unit = {},

    var mLocalStorageReducer: ReducerInstance<LocalStorageDAO.LocalStorageState, LocalStorageDAO.ELocalStorageAction>
) {
    operator fun getValue(nothing: Nothing?, property: KProperty<*>): MyAppContext {
        return this
    }


}
